module.exports = __webpack_public_path__ + "static/img/icon_guanbi.4bda41fa.png";